import React from "react";
import { useParams } from "react-router-dom";
import { setToaster } from "../components/Toaster";
import { ToastContainer } from "react-toastify";
import { AxiosError } from "axios";
import { MakeRequest } from "../components/DataUtil";
import {
  initializeCartData,
  getCurrentCart,
  updateCart,
} from "../components/ShoppingCart/CartData";
import SmallSpinner from "../components/SmallSpinner";
import { GetTokenFromLocalStorage } from "../components/Account/AuthenticationContext";
import PaintingAdminForm from "../components/Paintings/PaintingAdminForm";
import { SmallAlert } from "../components/SmallAlert";
import { Redirect } from "../components/Utilities";
import { getStore } from "../components/Stores";
import Select from "react-select";
import { getCustomStyles } from "../components/Utilities";

let sizeOptions: any[];

interface Props {
  Params?: any;
  Title: string;
}

interface State {
  data: any;
  isLoading: boolean;
  noData: boolean;
  sizeValue: string;
  sizeId: number;
  cart: any;
  token: string;
  renderCount: number;
  isDeleting: boolean;
  redirect: boolean;
  sizes: any;
  selectedSize: any;
  prints: any;
  printPrice: any;
  printShipping: any;
  paintingShipping: any;
}

class PaintingDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      noData: false,
      sizeValue: "",
      sizeId: 0,
      cart: [],
      token: GetTokenFromLocalStorage(),
      renderCount: 0,
      isDeleting: false,
      redirect: false,
      sizes: {},
      selectedSize: "",
      prints: [],
      printPrice: 0,
      printShipping: 0,
      paintingShipping: 0,
    };
    this.handleAddPaintingToCart = this.handleAddPaintingToCart.bind(this);
    this.handleComissionInquiry = this.handleComissionInquiry.bind(this);
    this.handleDeleting = this.handleDeleting.bind(this);
    this.handlePaintingDelete = this.handlePaintingDelete.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.handleAddPrintToCart = this.handleAddPrintToCart.bind(this);
  }
  onToaster = (state: any, message: string): void => {
    setToaster({
      state: state,
      message: message,
    });
  };

  async loadData(): Promise<any> {
    const successCallback = (result: any): void => {
      if (
        result &&
        result.Success &&
        result.Data &&
        result.Data !== undefined
      ) {
        this.setState({
          data: result.Data,
          noData: false,
          isLoading: false,
          renderCount: this.state.renderCount + 1,
        });
      } else {
        this.setState({ isLoading: false, noData: true });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false, noData: true }, () => {
          setToaster({
            state: { error: true },
            message: error.response ? error.message : "Unknown Error",
          });
        });
      }
    };
    this.setState({ isLoading: true }, async () => {
      const { Params } = this.props.Params;
      await MakeRequest({
        url: "Painting/GetPaintingDetails",
        method: "get",
        data: {
          querystringParams: "/'" + Params,
        },
        successCallback,
        errorCallback,
      });
    });
  }
  async loadPrints(): Promise<any> {
    const successCallback = (result: any): void => {
      if (
        result &&
        result.Success &&
        result.Data &&
        result.Data !== undefined
      ) {
        this.setState(
          {
            prints: result.Data,
          },
          () => {
            sizeOptions = this.state.prints.map((item: any) => {
              return { label: item.SizeValue, value: item.SizeId };
            });
            this.setState({ renderCount: this.state.renderCount + 1 });
          },
        );
      } else {
        this.setState({ isLoading: false, noData: true });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false, noData: true }, () => {
          setToaster({
            state: { error: true },
            message: error.response ? error.message : "Unknown Error",
          });
        });
      }
    };
    this.setState({ isLoading: true }, async () => {
      await MakeRequest({
        url: "Painting/GetPrints",
        method: "get",
        data: {},
        successCallback,
        errorCallback,
      });
    });
  }
  getShippingPrice = (shippingType: number): void => {
    let shippingData: any = getStore("Shipping");
    shippingData.forEach((item: any) => {
      switch (shippingType) {
        case 0:
          if (
            this.state.data.SizeId === item.SizeId &&
            shippingType === item.Type &&
            item.Enabled
          ) {
            this.setState({ paintingShipping: item.Price });
          }
          break;
        case 1:
          if (
            this.state.sizeId === item.SizeId &&
            shippingType === item.Type &&
            item.Enabled
          ) {
            this.setState({ printShipping: item.Price });
          }
          break;
      }
    });
  };
  async addCartItem(shippingType: number): Promise<any> {
    //calculate shipping for this item
    let shippingData: any = getStore("Shipping");
    let shippingItem = shippingData.find((item: any) => {
      if (shippingType === 0) {
        if (
          this.state.data.SizeId === item.SizeId &&
          shippingType === item.Type &&
          item.Enabled
        ) {
          return item;
        }
      } else if (shippingType === 1) {
        if (
          this.state.selectedSize.value === item.SizeId &&
          shippingType === item.Type &&
          item.Enabled
        ) {
          return item;
        }
      }
      return null;
    });
    //get new item
    let cartItem: any;

    if (shippingType === 0) {
      cartItem = {
        id: this.state.data.PaintingId,
        totalUnitsAmount:
          this.state.data.DiscountPrice > 0
            ? this.state.data.DiscountPrice
            : this.state.data.Price,
        singleUnitAmount:
          this.state.data.DiscountPrice > 0
            ? this.state.data.DiscountPrice
            : this.state.data.Price,
        item_name: this.state.data.Title,
        quantity: 1,
        paintingName: this.state.data.PaintingName,
        paintingPath: this.state.data.PaintingPath,
        thumbPath:
          this.state.data.PaintingPath +
          "thumbs/" +
          "small_" +
          this.state.data.PaintingName,
        medium: this.state.data.Medium,
        isSold: this.state.data.IsSold,
        size: this.state.data.Size,
        sizeId: this.state.data.SizeId,
        discount: this.state.data.Discount,
        discountAmount: this.state.data.DiscountAmount,
        type: shippingType,
        shippingPrice:
          shippingItem === null || shippingItem === undefined
            ? 0
            : shippingItem.Price,
      };
    } else if (shippingType === 1) {
      cartItem = {
        id: this.state.data.PaintingId + "_print",
        totalUnitsAmount: this.state.printPrice,
        singleUnitAmount: this.state.printPrice,
        item_name:
          this.state.data.Title +
          " (Print " +
          this.state.selectedSize.label +
          " )",
        quantity: 1,
        paintingName: this.state.data.PaintingName,
        paintingPath: this.state.data.PaintingPath,
        thumbPath:
          this.state.data.PaintingPath +
          "thumbs/" +
          "small_" +
          this.state.data.PaintingName,
        medium: "Print",
        isSold: false,
        size: this.state.selectedSize.label,
        sizeId: this.state.selectedSize.value,
        discount: 0,
        discountAmount: 0,
        type: shippingType,
        shippingPrice:
          shippingItem === null || shippingItem === undefined
            ? 0
            : shippingItem.Price,
      };
    }

    //add to card section
    let currentCart: any = getCurrentCart("Cart");
    let doUpdate: boolean = false;

    //add the item to the cart and save to state
    if (currentCart.length > 0) {
      const found = currentCart.find(
        (item: any) =>
          item.id === cartItem.id &&
          item.type === shippingType &&
          item.sizeId === cartItem.sizeId,
      );
      if (found === null || found === undefined) {
        currentCart.push(cartItem);
        doUpdate = true;
      } else {
        setToaster({
          state: { error: true },
          message: "That item is already in your cart",
        });
      }
    } else {
      currentCart.push(cartItem);
      doUpdate = true;
    }

    //update cart
    if (doUpdate) {
      updateCart(currentCart, "Cart");
    }
  }
  async delete(): Promise<any> {
    const successCallback = (result: any): void => {
      if (result && result.Success) {
        setToaster({
          state: { success: true },
          message: "Success: Painting deleted ",
        });
        this.setState({ isLoading: false, redirect: true });
      } else {
        setToaster({
          state: { error: true },
          message: "Error: Could not delete painting",
        });
        this.setState({ isLoading: false });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        setToaster({
          state: { error: true },
          message: error.response ? error.message : "Unknown Error",
        });
      }
    };
    this.setState({ isLoading: true }, async () => {
      await MakeRequest({
        url: "Admin/DeletePainting",
        method: "get",
        data: {
          querystringParams: "/" + this.state.data.PaintingId,
        },
        successCallback,
        errorCallback,
      });
    });
  }
  handleAddPaintingToCart = (): void => {
    this.addCartItem(0);
  };
  handleAddPrintToCart = (): void => {
    this.addCartItem(1);
  };
  handleDeleting(e: any): void {
    e.preventDefault();
    this.setState({ isDeleting: true });
  }
  handlePaintingDelete(e: any): void {
    e.preventDefault();
    this.setState({ isDeleting: false });
    this.delete();
  }
  handleComissionInquiry = (): void => {};
  handleSizeChange = (e: any): void => {
    this.setState(
      { sizeValue: e.label, sizeId: e.value, selectedSize: e },
      () => {
        //update print price
        let printFound: any = this.state.prints.find(
          (print: any) => print.SizeId === this.state.sizeId,
        );
        if (printFound && printFound !== undefined) {
          this.setState({ printPrice: printFound.Price });
        }
      },
    );
  };
  componentDidMount() {
    let loadPromise: any = Promise.resolve([]);
    const promises: any = [];
    promises.push(this.loadData());
    promises.push(this.loadPrints());

    loadPromise = Promise.all(promises).then(() => {
      //set up session storage
      initializeCartData("Cart");
    });
  }
  render() {
    let fullPath: string =
      this.state.data.PaintingPath + this.state.data.PaintingName;

    return (
      <>
        <div className="wrapper">
          <div className="section latest-offers">
            <div className="container">
              <h3 className="section-title">{this.props.Title}</h3>
              <hr />
              <div className="center">
                <SmallSpinner
                  isLoading={this.state.isLoading}
                  actionText="Loading"
                />
              </div>
              <div className="row">
                <div className="col-md-7 col-sm-6">
                  <div id="carousel" className="ml-auto mr-auto">
                    <img
                      src={fullPath.toString()}
                      alt=""
                      className="img-rounded img-responsive"
                    />
                  </div>
                </div>
                {this.state.token === null || this.state.token === "" ? (
                  <div className="col-md-5 col-sm-6">
                    <h2>{this.state.data.Title}</h2>
                    {this.state.data.Discount > 0 ? (
                      <h4 className="price">
                        <s>£{this.state.data.Price}</s>&nbsp;
                        <strong>£{this.state.data.DiscountPrice}</strong>
                        <span className="text-danger">
                          {" "}
                          - {this.state.data.Discount}%
                        </span>
                      </h4>
                    ) : !this.state.data.IsSold ? (
                      <h4 className="price">
                        <strong>£{this.state.data.Price}</strong>
                      </h4>
                    ) : (
                      <>
                        <br />
                        <span className="badge badge-pill badge-red">
                          &nbsp;
                        </span>
                        <span className="price text-danger">Sold</span>
                      </>
                    )}
                    <hr />
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        Medium: {this.state.data.Medium}
                      </div>
                      <div className="col-md-6 col-sm-6">
                        Size: {this.state.data.Size}
                      </div>
                    </div>
                    <hr />
                    {!this.state.data.IsSold ? (
                      <div className="row">
                        <div className="col-md-7 col-sm-8">
                          <button
                            className="btn btn-default btn-block btn-round"
                            onClick={this.handleAddPaintingToCart}
                          >
                            Add to Cart &nbsp;
                            <i className="fa fa-chevron-right"></i>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-12 col-sm-12">
                        If you would like to commission this painting, please
                        contact me at hanna@hannakaciniel.com
                      </div>
                    )}
                  </div>
                ) : (
                  <PaintingAdminForm
                    key={"key_" + this.state.renderCount}
                    paintingId={this.state.data.PaintingId}
                    onToaster={this.onToaster}
                    onDelete={this.handleDeleting}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.token !== null && this.state.token !== "" && (
          <SmallAlert
            id="smallAlertModalUser"
            message={"Are you sure you want to delete this painting?"}
            cancel="Cancel"
            confirm="Yes"
            isVisible={this.state.isDeleting}
            onDelete={this.handlePaintingDelete}
          />
        )}

        <ToastContainer autoClose={2000} />
        {this.state.redirect && <Redirect path="/" />}
      </>
    );
  }
}
const Details = (props: Props) => (
  <PaintingDetails {...props} Params={useParams()} />
);
export default Details;
